export default function (mtnUser) {
    return {
        username: mtnUser.Username,
        msisdn: mtnUser.Msisdn,
        status: getStatus(mtnUser.Status),
        subscriptionId: mtnUser.SubscriptionId,
        campaignId: mtnUser.CampaignId,
        activatedAt: mtnUser.DateAdded,
        optInServiceMsgs: mtnUser.OptInServiceMsgs,
        optInContentMsgs: mtnUser.OptInServiceMsgs,
        avatar: mtnUser.Avatar,
        automatedEntries: mtnUser.AutomatedEntries,
        freePlayService: mtnUser.FreeToPlay,
        serviceId: mtnUser.Service,
        externalRef: 12335642,
    }
}

function getStatus(mtnStatus) {
    const status = `${mtnStatus || ''}`.toLowerCase()
    if (status === 'active') return 'Active'
    if (status === 'pending') return 'Pending'
    return mtnStatus
}
